<!-- 运维管理 -->
<template>

  <v-card class="gm-card rounded-xl pa-4 " variant="text" :loading="statisticalLoading">
    <div class="d-flex align-center">
      <SwitchTab v-model="text" @change="handleToggleType">
        <SwitchTabItem value="1">月度</SwitchTabItem>
        <SwitchTabItem value="2">季度</SwitchTabItem>
        <SwitchTabItem value="3">年度</SwitchTabItem>
      </SwitchTab>

      <div style="width: 200px; margin-left: 16px;">
        <MonthSelect v-if="text == '1'" v-model="selectedMonth" @update:model-value="() => fetchStatisticalData()" />
        <QuarterPicker v-if="text == '2'" v-model="selectedQuarters" label="" placeholder="点击选择季度" :multiple="false"
          @change="handleChange" />
        <YearPicker v-if="text == '3'" v-model="selectedYears" label="" placeholder="选择单个年份" :multiple="false"
          @change="handleYearChange" />
      </div>
    </div>

    <div class="d-flex ga-4 mt-4">
      <DataCard class="data-card custom-card-bg" title="设备整体可用率"
        :subtitle="ov('compareAvailableRate') >= 0 ? '环比提升' : '环比下降'"
        :compareValue="Math.abs(ov('compareAvailableRate'))" :value="ov('thisAvailableRate', true)" unit="%"
        icon="chart-line" :value-style="valueStyle" :arrow-direction="ov('compareAvailableRate') >= 0 ? 'up' : 'down'">
        <template #icon>
          <img src="./imgs/op-01.png" width="48" alt="" srcset="">
        </template>
      </DataCard>
      <DataCard class="data-card  custom-card-bg" title="故障数" :subtitle="ov('compareAlarmNum') >= 0 ? '环比增加' : '环比减少'"
        :compareValue="Math.abs(ov('compareAlarmNum'))" :value="ov('thisAlarmNum')" unit="条" icon="chart-line"
        :value-style="valueStyle" :arrow-direction="ov('compareAlarmNum') >= 0 ? 'up' : 'down'">
        <template #icon>
          <img src="./imgs/op-02.png" width="48" alt="" srcset="">
        </template>
      </DataCard>
      <DataCard class="data-card  custom-card-bg" title="工单数量" :subtitle="ov('compareOrderNum') >= 0 ? '环比增加' : '环比减少'"
        :compareValue="Math.abs(ov('compareOrderNum'))" :value="ov('thisOrderNum')" unit="个" icon="chart-line"
        :value-style="valueStyle" :arrow-direction="ov('compareOrderNum') >= 0 ? 'up' : 'down'">
        <template #icon>
          <img src="./imgs/op-03.png" width="48" alt="" srcset="">
        </template>
      </DataCard>
      <DataCard class="data-card custom-card-bg" title="新投运电站"
        :subtitle="ov('compareStationNum') >= 0 ? '环比增加' : '环比减少'" :compareValue="Math.abs(ov('compareStationNum'))"
        :value="ov('thisStationNum')" unit="个" icon="chart-line" :value-style="valueStyle"
        :arrow-direction="ov('compareStationNum') >= 0 ? 'up' : 'down'">
        <template #icon>
          <img src="./imgs/op-04.png" width="48" alt="" srcset="">
        </template>
      </DataCard>
    </div>

    <div class="d-flex mt-4 ga-4 ops-chart-row">
      <v-card style="flex: 3" variant="text" rounded="xl" class="custom-card-bg ops-chart-card">
        <div style="height: 250px;" ref="chart1"></div>
      </v-card>
      <v-card variant="text" rounded="xl" class="custom-card-bg fault-type-card">
        <div class="fault-type-content">
          <div class="fault-type-chart" ref="chart2"></div>
          <div class="chart-legend fault-type-legend">
            <div v-for="(item, index) in faultTypeLegendList" :key="item.name" class="chart-legend-item">
              <span class="chart-legend-dot" :style="{ background: item.color }"></span>
              <span class="chart-legend-name">{{ item.name }}</span>
              <span class="chart-legend-count">{{ item.value }}条</span>
              <span class="chart-legend-pct">{{ item.pct }}%</span>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-card>

  <div class="d-flex mt-4 ga-4">
    <v-card style="flex: 1" variant="text" rounded="xl" class="gm-card" :loading="stationLoading">
      <div style="height: 250px;" ref="chart3"></div>
    </v-card>
    <v-card style="flex: 1" variant="text" rounded="xl" class="gm-card" :loading="stationLoading">
      <div style="height: 250px;" ref="chart4"></div>
    </v-card>
  </div>

  <div class="mt-4 ">

    <v-card class="gm-card px-4" variant="text" rounded="xl" :loading="tableLoading">
      <template #title>
        <div class="d-flex align-center justify-space-between">
          各电站关键运维指标
          <div class="station-search">
            <v-text-field v-model="searchKeyword" placeholder="输入电站名称或id搜索" rounded="pill" variant="outlined"
              density="compact" hide-details clearable class="search-input" style="width: 250px;" @input="handleSearch"
              @keyup.enter="handleSearchEnter" @click:clear="handleSearch">
              <template #append-inner>
                <v-icon icon="mdi-magnify" size="small" class="search-icon" @click="handleSearch" />
              </template>
            </v-text-field>
          </div>
        </div>
      </template>
      <v-table style="width: 100%;background: transparent; " class="gm-table ops-station-table">
        <thead>
          <tr>
            <th style="width: 35%;">电站</th>
            <th style="width: 15%;">设备可用率(%)</th>
            <th style="width: 15%;">在线时长(小时)</th>
            <th style="width: 15%;">故障数(条)</th>
            <th style="width: 15%;">工单数(个)</th>
            <th style="width: 6%;">SOH(%)</th>
            <th style="width: 8%; text-align: center;">操作</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="item in stationList" :key="item.id">
            <td>
              <div>
                <div class="station-name" style="cursor: pointer" @click="handleDetail(item)">{{ item.name || '-' }}
                </div>
                <div class="station-capacity">{{ (item.maxPower / 1000).toFixed(2) }} MW / {{
                  (item.capacity / 1000).toFixed(2) }}
                  MWh
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex align-center ga-2">
                <v-progress-circular :model-value="fmtper(item.availableRate)" :size="20"
                  color="#EF222D"></v-progress-circular>
                {{ fmtper(item.availableRate) }}
              </div>
            </td>
            <td>{{ item.onlineDuration ?? '--' }}</td>
            <td>{{ item.alarmNum ?? '--' }}</td>
            <td>{{ item.orderNum ?? '--' }}</td>
            <td>
              {{ item.soh }}
              <v-progress-linear :model-value="item.soh" color="#18C345" rounded></v-progress-linear>
            </td>
            <td style="text-align: center;">
              <v-btn variant="text" size="small" color="var(--color-primary)" @click="handleDetail(item)"
                rounded="xl">详情</v-btn>
            </td>
          </tr>

        </tbody>
      </v-table>
      <div v-if="stationList.length === 0" class="empty-tip text-center py-8 text-medium-emphasis">
        {{ searchKeyword ? '未找到匹配的电站' : '暂无电站数据' }}
      </div>

      <TablePagination :total="stationCount" :pageSize="pageSize" v-model="page" @change="() => fetchStationList()" />
    </v-card>
  </div>

</template>

<script setup>
import { onMounted, ref, useTemplateRef } from 'vue'
import DataCard from '@/components/DataCard/index.vue'
import { initChart } from '@/utils/index.js'
import dayjs from 'dayjs'

import SwitchTab from '@/components/SwitchTab/SwitchTab.vue'
import SwitchTabItem from '@/components/SwitchTab/SwitchTabItem.vue'
import MonthSelect from '@/components/MonthSelect/index.vue'
import QuarterPicker from '@/components/QuarterPicker/index.vue'
import YearPicker from '@/components/YearPicker/index.vue'
import TablePagination from '@/components/TablePagination/index.vue'

import Opt1 from './opts/opt1.js'
import Opt2 from './opts/opt2.js'
import Opt3 from './opts/opt3.js'
import Opt4 from './opts/opt4.js'


import * as api from '@/api/it-operations.js'
import { useRouter } from 'vue-router'
import { stationSearchNameOrId } from '@/utils/stationSearchQuery.js'
const router = useRouter()

const text = ref('1')
const chart1Ref = useTemplateRef('chart1')
const chart2Ref = useTemplateRef('chart2')
const chart3Ref = useTemplateRef('chart3')
const chart4Ref = useTemplateRef('chart4')


const selectedMonth = ref(dayjs().format('YYYY-MM'))
const selectedQuarters = ref([{
  year: getCurrentYear(),
  quarter: getCurrentQuarter(),
}])
const selectedYears = ref([getCurrentYear()])

function getCurrentQuarter() {
  return Math.ceil((new Date().getMonth() + 1) / 3)
}

function getCurrentYear() {
  return new Date().getFullYear()
}

function getCurrentMonth() {
  return new Date().getMonth() + 1
}

function getParams() {
  if (text.value == '1') {
    return {
      type: text.value,
      year: selectedMonth.value.split('-')[0] || getCurrentYear(),
      index: selectedMonth.value.split('-')[1] || getCurrentMonth(),
    }
  } else if (text.value == '2') {
    return {
      type: text.value,
      year: selectedQuarters.value?.[0]?.year || getCurrentYear(),
      index: selectedQuarters.value?.[0]?.quarter || getCurrentQuarter(),
    }
  } else if (text.value == '3') {
    return {
      type: text.value,
      year: selectedYears.value?.[0] || getCurrentYear(),
      index: '',
    }
  }
}

function handleChange(val) {
  console.log('季度选择已变更:', val)
  fetchStatisticalData()
}

function handleYearChange(val) {
  console.log('年份选择已变更:', val)
  fetchStatisticalData()
}

const page = ref(1)
const totalPages = ref(0)
const pageSize = ref(10)

const valueStyle = {
  'font-size': '20px',
  'font-weight': '600',
}


const stationList = ref([])
const searchKeyword = ref('')

// 搜索防抖和节流
let searchDebounceTimer = null
let searchLastFetchAt = 0
const SEARCH_DEBOUNCE_MS = 300
const SEARCH_THROTTLE_MS = 500

function execSearchFetch({ useThrottle = false } = {}) {
  const now = Date.now()
  if (useThrottle && now - searchLastFetchAt < SEARCH_THROTTLE_MS) return

  page.value = 1
  fetchStationList()
  searchLastFetchAt = now
}

function handleSearch() {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
  searchDebounceTimer = setTimeout(() => {
    execSearchFetch()
    searchDebounceTimer = null
  }, SEARCH_DEBOUNCE_MS)
}

function handleSearchEnter() {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
  execSearchFetch({ useThrottle: true })
}


function handleToggleType(type) {
  selectedMonth.value = dayjs().format('YYYY-MM')
  selectedQuarters.value = [{
    year: getCurrentYear(),
    quarter: getCurrentQuarter(),
  }]
  selectedYears.value = [getCurrentYear()]

  fetchStatisticalData()
}


function fmtper(value) {
  if (value === void 0) {
    return '--'
  }
  return (value * 100).toFixed(2)
}


const charts = {
  chart1: null,
  chart2: null,
  chart3: null,
  chart4: null,
}

function initCharts() {
  charts.chart1 = initChart(chart1Ref.value, null, Opt1([], text.value))
  charts.chart2 = initChart(chart2Ref.value, null, Opt2())
  charts.chart3 = initChart(chart3Ref.value, null, Opt3())
  charts.chart4 = initChart(chart4Ref.value, null, Opt4())
}

function updateChart1() {
  charts.chart1.setOption(Opt1(statisticalData.value.alarmStatistics, text.value))
}

function updateChart2() {
  charts.chart2.setOption(Opt2(statisticalData.value.alarmType))
}

function updateChart3() {
  charts.chart3.setOption(Opt3(stationData.value.station))
}

function updateChart4() {
  charts.chart4.setOption(Opt4(stationData.value.model))
}


onMounted(() => {
  initCharts()
})

const statisticalData = ref({})

// 从statisticalData中获取overview的属性值
function ov(key, mui100 = false) {
  const value = statisticalData.value.overview?.[key] || 0
  return mui100 ? (value * 100).toFixed(2) : value
}


const statisticalLoading = ref(false)
// 运维总览数据
async function fetchStatisticalData() {
  statisticalLoading.value = true

  try {
    const params = getParams()
    const res = await api.queryStatisticalData(params)
    console.log('res', res)
    statisticalData.value = res.data || {}
    updateChart1()
    updateChart2()
  } catch (error) {
    console.log('error', error)
  } finally {
    statisticalLoading.value = false
  }
  const params = getParams()
  const res = await api.queryStatisticalData(params)
  console.log('res', res)
  statisticalData.value = res.data || {}

  // 更新故障类型图例数据
  const chartData = statisticalData.value.alarmType || {}
  const total = (chartData.safety || 0) + (chartData.income || 0) + (chartData.device || 0) + (chartData.other || 0)
  const colors = ['#3E82EF', '#91BBFF', '#FF2E55', '#FCAD50', '#59D681']
  faultTypeLegendList.value = [
    { value: chartData.safety || 0, name: '安全类', color: colors[0] },
    { value: chartData.income || 0, name: '收益类', color: colors[1] },
    { value: chartData.device || 0, name: '设备类', color: colors[2] },
    { value: chartData.other || 0, name: '其他类', color: colors[3] },
  ].map(item => ({
    ...item,
    pct: total > 0 ? Math.round((item.value / total) * 10000) / 100 : 0
  }))

  updateChart1()
  updateChart2()
}

const stationData = ref({})
const stationLoading = ref(false)
const faultTypeLegendList = ref([])
// 电站和设备型号统计
async function fetchStationData() {
  stationLoading.value = true

  try {
    const res = await api.queryStationData()
    console.log('res1', res)
    stationData.value = res.data || {}
    updateChart3()
    updateChart4()
  } catch (error) {
    console.log('error', error)
  } finally {
    stationLoading.value = false
  }
}


const stationCount = ref(0)
const tableLoading = ref(0)
// 电站数据列表
async function fetchStationList() {
  const { name, stationId } = stationSearchNameOrId(searchKeyword.value)
  tableLoading.value = true
  const res = await api.queryStationList({
    name,
    stationId,
    pageNum: page.value,
    pageSize: pageSize.value,
  })
  console.log('res', res)
  stationList.value = res.rows
  totalPages.value = Math.ceil(res.total / pageSize.value)
  stationCount.value = res.total
  tableLoading.value = false
}

fetchStatisticalData()
fetchStationData()
fetchStationList()

function handleDetail(item) {
  router.push({
    path: '/it-operations/detail',
    query: {
      stationId: item.stationId,
      tab: '告警信息'
    }
  })
}

</script>

<style scoped lang="scss">
.data-card {
  min-width: 300px;
  padding: 20px 24px;
  flex-direction: row-reverse;
  justify-content: space-around;
  flex: 1;
}

.custom-card-bg {
  background: linear-gradient(171.53deg, #E7F3FF -10.92%, rgba(247, 251, 255, 0.3) 36.46%);
  border: 1px solid #E9EFFF;
}

.ops-chart-row {
  min-width: 0;
}

.ops-chart-card {
  min-width: 0;
}

.fault-type-card {
  flex: 1;
  min-width: 320px;
}

.fault-type-content {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 250px;
}

.fault-type-chart {
  flex: 1;
  min-width: 140px;
  height: 100%;
}

.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
  padding: 10px;
}

.chart-legend.fault-type-legend {
  padding: 0 24px 0 20px;
}

.station-name {
  color: var(--color-primary);
  transition: text-decoration 0.2s ease;
}

.chart-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  padding: 8px 12px;
  background: #E8ECF5;
  border-radius: 8px;
  font-size: 12px;
  border: 2px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.chart-legend-item:hover {
  background: #dee4f0;
}

.chart-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chart-legend-name {
  color: rgba(46, 46, 46, 0.85);
  flex: 1;
  white-space: nowrap;
}

.chart-legend-count {
  color: rgba(46, 46, 46, 0.85);
  white-space: nowrap;
}

.chart-legend-pct {
  color: rgba(46, 46, 46, 0.85);
  margin-left: 4px;
  white-space: nowrap;
}


.chart-legend.fault-type-legend .chart-legend-count {
  flex: 0 0 54px;
  width: 54px;
  min-width: 54px;
  text-align: right;
}

.chart-legend.fault-type-legend .chart-legend-pct {
  flex: 0 0 36px;
  width: 36px;
  min-width: 36px;
  margin-left: 0;
  text-align: right;
}

.station-search {
  .search-icon {
    cursor: pointer;
  }

  // :deep(.v-field__outline) {
  //   border-radius: 16px !important;
  //   border: 1px solid #d4d9e5 !important;
  // }
}

.gm-table {
  :deep(.v-table__wrapper) {
    border-radius: 0;
  }
}

.ops-station-table {
  :deep(table) {
    table-layout: fixed;
  }

  :deep(td) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .station-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .station-capacity {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (max-width: 1400px),
(max-height: 800px) {
  .fault-type-card {
    min-width: 260px;
  }

  .fault-type-content {
    align-items: stretch;
    flex-direction: column;
    height: auto;
    min-height: 250px;
  }

  .fault-type-chart {
    flex: 0 0 150px;
    min-height: 150px;
    width: 100%;
    margin-top: 10px;
  }

  .chart-legend.fault-type-legend {
    flex: 0 0 auto;
    padding: 0 24px 12px 12px;
  }

  .chart-legend.fault-type-legend .chart-legend-count {
    flex-basis: 54px;
    width: 54px;
    min-width: 54px;
  }

  .chart-legend.fault-type-legend .chart-legend-pct {
    flex-basis: 48px;
    width: 48px;
    min-width: 48px;
  }

  .chart-legend-item {
    padding: 6px 8px;
    gap: 4px;
    font-size: 11px;
  }

  .chart-legend-dot {
    width: 6px;
    height: 6px;
  }

  .chart-legend-count,
  .chart-legend-pct {
    flex: 0 0 auto;
    min-width: 32px;
    text-align: right;
  }

  .chart-legend-name {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 1401px) and (max-width: 1919px) {
  .fault-type-card {
    min-width: 300px;
  }

  .fault-type-content {
    align-items: stretch;
    flex-direction: column;
    height: auto;
    min-height: 250px;
  }

  .fault-type-chart {
    flex: 0 0 155px;
    min-height: 155px;
    width: 100%;
    margin-top: 8px;
  }

  .chart-legend.fault-type-legend {
    flex: 0 0 auto;
    padding: 0 24px 12px 14px;
  }

  .chart-legend.fault-type-legend .chart-legend-count {
    flex-basis: 54px;
    width: 54px;
    min-width: 54px;
  }

  .chart-legend.fault-type-legend .chart-legend-pct {
    flex-basis: 48px;
    width: 48px;
    min-width: 48px;
  }

  .chart-legend-item {
    padding: 7px 10px;
    gap: 6px;
    font-size: 11px;
  }

  .chart-legend-count,
  .chart-legend-pct {
    flex: 0 0 auto;
    min-width: 40px;
    text-align: right;
  }
}
</style>
